import { useId } from "react";

export default function ComboInput({ value, onChange, options = [], placeholder, testid, upper = true }) {
  const id = useId();
  const isNew = value && !options.includes(value);
  return (
    <div className="combo-row">
      <input list={id} value={value} onChange={(e) => onChange(upper ? e.target.value.toUpperCase() : e.target.value)} placeholder={placeholder} autoComplete="off" data-testid={`${testid}-input`} />
      <datalist id={id}>{options.map((o) => <option key={o} value={o} />)}</datalist>
      {isNew && <small className="muted" data-testid={`${testid}-new-note`}>Baru — akan otomatis masuk Master Data / 新数据将自动加入主数据</small>}
    </div>
  );
}
